(function () {
  const PAGE_SELECTOR = '.Vtl-WishlistPage';
  const CARD_SELECTOR = '.Vtl-WishlistProduct';
  const LINK_SELECTOR = '.Vtl-WishlistProduct__Link';
  const ADD_BUTTON_SELECTOR = '.Vtl-WishlistProduct__AddToCart';
  const POPUP_SELECTOR = '[data-quick-add-popup]';
  const TOGGLE_SELECTOR = '[data-quick-add-toggle]';
  const SIZE_OPTION_SELECTOR = '.productCard__sizeOption';
  const PROCESSED_ATTR = 'data-quick-add-ready';

  const TOGGLE_CLASSES =
    'productCard__addButton absolute bottom-[5.6rem] left-[1rem] w-[3.3rem] h-[3.3rem] ' +
    '@[24rem]:bottom-[5.6rem] @[24rem]:left-[1.6rem] @[24rem]:w-[2.4rem] @[24rem]:h-[2.4rem] ' +
    'opacity-50 bg-white/90 backdrop-blur-lg flex items-center justify-center hover:bg-white ' +
    'hover:opacity-100 transition-all cursor-pointer border-none z-20 pointer-events-auto';
  const TOGGLE_ICON_CLASSES =
    'productCard__addIcon w-[1.6rem] h-[1.6rem] sm:w-[1.1rem] sm:h-[1.1rem] transition-transform duration-300';
  const POPUP_CLASSES =
    'productCard__sizePopup absolute bottom-[9.9rem] left-[1rem] right-[1rem] ' +
    '@[24rem]:bottom-[8rem] @[24rem]:left-[1.6rem] @[24rem]:right-[1.6rem] bg-white/60 backdrop-blur-lg ' +
    'px-[1rem] py-[1.6rem] @[24rem]:p-[1.6rem] flex flex-col gap-[2.4rem] transition-all duration-300 ' +
    'opacity-0 invisible translate-y-[0.5rem] z-10 pointer-events-auto';
  const POPUP_TITLE_CLASSES = 'productCard__popupTitle text-[0.9rem] text-black truncate capitalize';
  const SIZES_ROW_CLASSES = 'productCard__sizes flex items-center gap-[1.6rem] text-[1rem]/[100%] text-black';
  const SIZE_OPTION_CLASSES = 'productCard__sizeOption hover:opacity-70 transition-opacity cursor-pointer bg-transparent border-none p-0';

  function getProductHandle(href) {
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/]+)/);
      return match ? match[1] : null;
    } catch (error) {
      return null;
    }
  }

  function getSizeOptionIndex(product) {
    const options = product.options || [];

    const names = options.map(function (option) {
      const name = typeof option === 'string' ? option : (option && option.name) || '';
      return name.toLowerCase();
    });
    const found = names.findIndex(function (name) {
      return name.indexOf('tamanho') !== -1 || name.indexOf('size') !== -1 || name === 'tam';
    });
    if (found !== -1) return found;
    return options.length > 1 ? options.length - 1 : 0;
  }

  function buildToggleButton() {
    const button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('data-quick-add-toggle', '');
    button.setAttribute('aria-label', 'Add to cart');
    button.className = TOGGLE_CLASSES;
    button.innerHTML =
      '<svg class="' + TOGGLE_ICON_CLASSES + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ' +
      'fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M12 5v14"/><path d="M5 12h14"/></svg>';
    return button;
  }

  const SIZE_LABEL_MAP = {
    PP: 'XS',
    P: 'S',
    M: 'M',
    G: 'L',
    GG: 'XL',
    DDD: 'F',
    'DOMAIN DRIVEN DESIGN': 'F',
    'DOMAIN-DRIVEN DESIGN': 'F',
    DDDD: 'G',
    H: 'H'
  };

  function translateSizeLabel(rawLabel) {
    if (rawLabel === 'Default Title') return 'UN';
    const upper = String(rawLabel).trim().toUpperCase();
    return SIZE_LABEL_MAP[upper] || upper;
  }

  function buildPopup(product) {
    const sizeIndex = getSizeOptionIndex(product);
    const seen = {};

    const popup = document.createElement('div');
    popup.setAttribute('data-quick-add-popup', '');
    popup.className = POPUP_CLASSES;

    const title = document.createElement('span');
    title.className = POPUP_TITLE_CLASSES;
    title.textContent = product.title;
    popup.appendChild(title);

    const sizesRow = document.createElement('div');
    sizesRow.className = SIZES_ROW_CLASSES;

    product.variants.forEach(function (variant) {
      const rawLabel = variant.options[sizeIndex] || 'Default Title';
      const label = translateSizeLabel(rawLabel);
      if (seen[label]) return;
      seen[label] = true;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = SIZE_OPTION_CLASSES + (variant.available ? '' : ' opacity-30');
      button.dataset.variantId = variant.id;
      button.dataset.size = label;
      button.textContent = label;
      sizesRow.appendChild(button);
    });

    popup.appendChild(sizesRow);
    return popup;
  }

  function findColorImage(product) {
    const images = product.images || [];
    for (let i = 0; i < images.length; i++) {
      const src = typeof images[i] === 'string' ? images[i] : images[i] && images[i].src;
      if (!src) continue;
      const filename = src.split('/').pop().split('?')[0].split('.')[0];
      if (filename.slice(-2) === '90') return src;
    }
    return null;
  }

  function buildColorVariantsRow(product, productUrl) {
    const colorImage = findColorImage(product);
    if (!colorImage) return null;

    const row = document.createElement('div');
    row.className =
      'productCard__colorVariants flex items-center gap-[0.4rem] pointer-events-auto ' +
      'transition-opacity duration-300 mt-[0.6rem] opacity-0 group-hover:opacity-100';
    row.setAttribute('data-main-colors', '');
    row.setAttribute('data-product-id', product.id);

    const swatch = document.createElement('a');
    swatch.href = productUrl;
    swatch.className = 'productCard__colorSwatch shrink-0 block w-[0.6rem] h-[0.6rem] transition-colors';
    swatch.style.boxShadow = '0px 0px 2px 0.5px rgba(0, 0, 0, 0.15)';
    swatch.title = product.title;

    const img = document.createElement('img');
    img.src = colorImage.split('?')[0] + '?width=32';
    img.alt = product.title;
    img.className = 'w-full h-full object-cover';
    img.width = 6;
    img.height = 6;
    swatch.appendChild(img);
    row.appendChild(swatch);

    const plus = document.createElement('span');
    plus.className = 'text-[1.1rem] leading-none text-gray-400 ml-[0.2rem]';
    plus.textContent = '+';
    row.appendChild(plus);

    return row;
  }

  function openPopup(card) {
    closeAllPopups(card);
    const popup = card.querySelector(POPUP_SELECTOR);
    const icon = card.querySelector(TOGGLE_SELECTOR + ' svg');
    if (!popup) return;

    popup.classList.remove('opacity-0', 'invisible', 'translate-y-[0.5rem]');
    popup.classList.add('opacity-100', 'visible', 'translate-y-0');
    if (icon) icon.classList.add('rotate-45');
  }

  function closePopup(card) {
    const popup = card.querySelector(POPUP_SELECTOR);
    const icon = card.querySelector(TOGGLE_SELECTOR + ' svg');
    if (!popup) return;

    popup.classList.add('opacity-0', 'invisible', 'translate-y-[0.5rem]');
    popup.classList.remove('opacity-100', 'visible', 'translate-y-0');
    if (icon) icon.classList.remove('rotate-45');
  }

  function closeAllPopups(exceptCard) {
    document.querySelectorAll(POPUP_SELECTOR + '.opacity-100').forEach(function (popup) {
      const card = popup.closest(CARD_SELECTOR);
      if (card && card !== exceptCard) closePopup(card);
    });
  }

  async function addVariantToCart(variantId, triggerEl, card) {
    if (!variantId || !window.CartManager) return;

    try {
      const result = await window.CartManager.addToCart(variantId, { button: triggerEl });
      if (result && result.success && card) closePopup(card);
    } catch (error) {
      console.error('[WishlistQuickAdd] Error adding to cart:', error);
    }
  }

  async function setupCard(card) {
    if (card.hasAttribute(PROCESSED_ATTR)) return;
    card.setAttribute(PROCESSED_ATTR, 'true');

    card.classList.add('@container', 'group');

    const link = card.querySelector(LINK_SELECTOR);
    const addButton = card.querySelector(ADD_BUTTON_SELECTOR);
    if (!link || !addButton) return;

    const handle = getProductHandle(link.getAttribute('href'));
    if (!handle) return;

    addButton.classList.add('wishlistQuickAdd__originalHidden');

    let product;
    try {
      const response = await fetch('/products/' + handle + '.js');
      if (!response.ok) {
        console.error('[WishlistQuickAdd] Product fetch not ok:', handle, response.status);
        return;
      }
      product = await response.json();
    } catch (error) {
      console.error('[WishlistQuickAdd] Error fetching product:', error);
      return;
    }

    const colorsRow = buildColorVariantsRow(product, link.getAttribute('href').split('?')[0]);
    if (colorsRow) {
      const wrapper = document.createElement('div');
      link.replaceWith(wrapper);
      wrapper.appendChild(link);
      wrapper.appendChild(colorsRow);
    }

    const variants = product.variants || [];
    const toggle = buildToggleButton();
    card.appendChild(toggle);

    if (variants.length <= 1) {
      console.warn('[WishlistQuickAdd] Product has 1 or fewer variants, skipping popup:', handle, product);
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        if (variants[0]) addVariantToCart(String(variants[0].id), toggle, null);
      });
      return;
    }

    let popup;
    try {
      popup = buildPopup(product);
    } catch (error) {
      console.error('[WishlistQuickAdd] Error building popup:', error, product);
      return;
    }
    card.appendChild(popup);

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (popup.classList.contains('opacity-0')) {
        openPopup(card);
      } else {
        closePopup(card);
      }
    });
  }

  function processAllCards(root) {
    root.querySelectorAll(CARD_SELECTOR).forEach(setupCard);
  }

  document.addEventListener('click', function (e) {
    const sizeButton = e.target.closest(SIZE_OPTION_SELECTOR);
    if (sizeButton) {
      const card = sizeButton.closest(CARD_SELECTOR);
      // Sem isso, cliques em .productCard__sizeOption fora da wishlist (ex: PLP)
      // também disparam este handler, duplicando a adição ao carrinho.
      if (!card) return;
      addVariantToCart(sizeButton.dataset.variantId, sizeButton, card);
      return;
    }

    if (!e.target.closest(TOGGLE_SELECTOR) && !e.target.closest(POPUP_SELECTOR)) {
      closeAllPopups();
    }
  });

  function startObserving(page) {
    processAllCards(page);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(CARD_SELECTOR)) {
            setupCard(node);
          } else if (node.querySelectorAll) {
            processAllCards(node);
          }
        });
      });
    });

    observer.observe(page, { childList: true, subtree: true });
  }

  function init() {
    const page = document.querySelector(PAGE_SELECTOR);
    if (page) {
      startObserving(page);
      return;
    }

    const bodyObserver = new MutationObserver(function () {
      const latePage = document.querySelector(PAGE_SELECTOR);
      if (latePage) {
        bodyObserver.disconnect();
        startObserving(latePage);
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
